import {
  Image,
  Picture,
  Box,
  Flex,
  Modal,
  Typography,
} from "@jewlr/storybook/core"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import scroll from "scroll"
import scrollDoc from "scroll-doc"
import styled from "styled-components"

import { jewlr_t, IS_UK } from "helpers/application"

const InfoBox = styled(Box).attrs((props) => ({
  color: "white",
  left: { _: "25%", tablet: "auto" },
  p: { desktop: 3, tablet: 1 },
  position: "absolute",
  top: { _: "34%", tablet: "auto" },
  ...props,
}))``

const InfoTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  fontSize: {
    _: "1.0em",
    tablet: "1.25em",
  },
  fontWeight: "normal",
  pb: { widescreen: 2 },
  ...props,
}))``
const scrollBackTop = () => {
  const page = scrollDoc()
  scroll.top(page, 0)
}

const About = () => {
  const [showShopperAlert, toggleShopperAlert] = useState(false)
  const ukImg = IS_UK() ? "-uk" : ""

  return (
    <Box contain lineHeight="copy" mb={1} pb={1}>
      <Box
        bg="primaryColors.oldlace"
        mb={1}
        p={1}
        px={{ desktop: "2em", widescreen: "10em" }}
        textAlign="center"
      >
        <Box mb={5} mt={4}>
          <Typography
            as="h1"
            fontWeight="normal"
            lineHeight={{ _: "38px", tablet: "1.5" }}
            mb={{ _: 1, tablet: "1.5em", widescreen: 2 }}
            variant="h1"
          >
            Fine {jewlr_t("terms.Jewelry")} Designed By You
          </Typography>
          <Typography
            as="p"
            fontSize={{ _: "1.3em", tablet: "1.5em" }}
            px={{ tablet: "3em" }}
            variant="body1"
          >
            Your {jewlr_t("terms.jewelry")}, your way. Design your own fine{" "}
            {jewlr_t("terms.jewelry")} in your choice of silver or gold, and a
            colourful palette of gemstones. Creating your unique fine{" "}
            {jewlr_t("terms.jewelry")} collection is an adventure, so play and
            have fun on your {jewlr_t("terms.jewelry")} journey.
          </Typography>
        </Box>

        <Picture
          alt="You can have it all!"
          fallback={require("images/leefiori/info/about-top-banner-2x.jpg")}
          pb="2em"
          px={{ desktop: "0px", tablet: "4em", widescreen: "4em" }}
          srcSet={[
            {
              media: "(max-width: 767px)",
              sizes: "355vw",
              srcSet: `
                          ${require("images/leefiori/info/mobile-about-top-banner.jpg")} 355w,
                          ${require("images/leefiori/info/mobile-about-top-banner-2x.jpg")} 710w
              `,
            },
            {
              media: "(min-width: 768px)",
              sizes: "830vw",
              srcSet: `
                          ${require("images/leefiori/info/about-top-banner.jpg")} 830w,
                          ${require("images/leefiori/info/about-top-banner-2x.jpg")} 1660w
              `,
            },
          ]}
          width="100%"
        />

        <Box
          m={{ tablet: "26px" }}
          px={{ desktop: "0px", tablet: "0px", widescreen: "7em" }}
        >
          <Typography
            as="p"
            fontSize={{ _: "1.1em", tablet: "1.5em" }}
            mb={{ _: "48px", tablet: 9 }}
            variant="body1"
          >
            At Lee Fiori, we let you be the designer! And there’s something for
            everyone… every style and every budget. Build your looks one piece
            at a time or enjoy the benefits of our multi-item discount.
          </Typography>
        </Box>
        <Box mb={{ _: 5, tablet: 8 }}>
          <Flex
            flexDirection={{ _: "column-reverse", tablet: "row" }}
            justifyContent={"space-evenly"}
          >
            <Box bg="white" flex={1}>
              <Box mt={{ _: 24, desktop: 8 }} pt={{ widescreen: 4 }}>
                <Image
                  alt="But How"
                  mb={{ _: 2, tablet: 3 }}
                  src={require("images/leefiori/info/title-But-How.svg")}
                  width={{ _: "200px", tablet: "240px" }}
                />

                <Typography
                  mb={{ _: 4, tablet: "0px" }}
                  mx={{
                    _: "12px",
                    desktop: "38px",
                    tablet: "27px",
                    widescreen: "45px",
                  }}
                  variant="body3"
                >
                  How do we do it? We handcraft your {jewlr_t("terms.jewelry")}{" "}
                  and send directly to you at below retail prices. That means no
                  middlemen and no crazy mark-ups. We pass on those savings to
                  you so you can get more for less.
                </Typography>
              </Box>
            </Box>
            <Box flex={1}>
              <Picture
                alt="Retail Price"
                fallback={require("images/leefiori/info/about-top-banner-2x.jpg")}
                srcSet={[
                  {
                    media: "(max-width: 767px)",
                    sizes: "100vw",
                    srcSet: `
                          ${require(`images/leefiori/info/mobie-process${ukImg}.jpg`)} 608w,
                          ${require(`images/leefiori/info/mobile-process-2x${ukImg}.jpg`)} 1216w
              `,
                  },
                  {
                    media: "(min-width: 768px)",
                    sizes: "608vw",
                    srcSet: `
                          ${require(`images/leefiori/info/process${ukImg}.jpg`)} 608w,
                          ${require(`images/leefiori/info/process-2x${ukImg}.jpg`)} 1216w
              `,
                  },
                ]}
              />
            </Box>
          </Flex>
        </Box>
        <Box mb={5} mt={2}>
          <Typography
            as="h2"
            fontSize={{ _: "1.6em", tablet: "2.25em" }}
            fontWeight="normal"
            mb={{ tablet: "2em" }}
            variant="h1"
          >
            “That means no middlemen and no
            <br /> crazy mark-ups.”{" "}
          </Typography>
        </Box>

        <Flex
          flexDirection={{ _: "column", tablet: "row" }}
          gutter={1}
          justifyContent={"center"}
        >
          <Box
            mb={{ _: "-6px", tablet: "0px" }}
            pl={{ tablet: "0px" }}
            position="relative"
            pr={{ tablet: "0px" }}
            width="100%"
          >
            <Image
              alt="Jewlr Craftsmanship"
              height="100%"
              src={require("images/leefiori/info/jewlr-craftsmanship.jpg")}
              width={{ _: "100%", desktop: "100%" }}
            />
            <Box
              left={{ _: "29%", tablet: "32%" }}
              position="absolute"
              right={{ _: "29%", tablet: "32%" }}
              top="37%"
            >
              <Image
                alt="Jewlr"
                src={require("images/leefiori/info/jewlr-logo.svg")}
                width="175px"
              />
            </Box>
            <Box
              left={{ _: "26%", tablet: "29%" }}
              position="absolute"
              right={{ _: "26%", tablet: "29%" }}
              top="45%"
            >
              <a
                className="shopperlink"
                href="https://www.shopperapproved.com/reviews/jewlr.com/"
              >
                <img
                  alt="Customer Reviews"
                  onContextMenu={() => {
                    toggleShopperAlert(true)
                  }}
                  src="//www.shopperapproved.com/newseals/13256/white-header-details.gif"
                  style={{ border: 0, marginTop: "8px" }}
                />
              </a>
            </Box>
          </Box>
          <Box
            bg="white"
            lineHeight="copy"
            p={{ _: "0px", tablet: 1 }}
            px={{ desktop: "20em" }}
            width={{ _: "100%", desktop: "100%" }}
          >
            <Box mt={{ desktop: 8 }} pt={{ _: 2, desktop: 6 }}>
              <Image
                alt="Believe It"
                mb={{ _: 2, tablet: 3 }}
                mt={{ _: 2, tablet: 0 }}
                src={require("images/leefiori/info/title-Believe-It.svg")}
                width={{ _: "200px", tablet: "240px" }}
              />

              <Typography
                mb={{ _: 4, tablet: "0px" }}
                mx={{ _: 3, tablet: 5 }}
                variant="body3"
              >
                From the creators of Jewlr, Lee Fiori is a specialty e-boutique
                for {jewlr_t("terms.jewelry")} for your every day – no occasion{" "}
                required! We make the {jewlr_t("terms.jewelry")} ourselves. Each
                piece is beautifully crafted in our {jewlr_t("terms.jewelry")}{" "}
                workshop in Toronto, Canada, with the same quality and expertise
                that have made Jewlr the leader in{" "}
                {jewlr_t("terms.personalized")} fine {jewlr_t("terms.jewelry")}.
              </Typography>
            </Box>
          </Box>
        </Flex>

        <Box
          pb={{ _: "0px", tablet: "5em" }}
          pt={{ _: 7, tablet: "6em" }}
          px={{ _: "1em", tablet: "3em" }}
        >
          <Flex
            flexDirection={{ _: "column", tablet: "row" }}
            gutter={1}
            justifyContent="space-evenly"
          >
            <Box
              flex={1}
              mb={{ _: 4, tablet: 0 }}
              onClick={() => scrollBackTop()}
              pointer
            >
              <Box
                alignItems="center"
                display={{ _: "block", tablet: "flex" }}
                flexDirection={{ tablet: "row-reverse" }}
                position="relative"
              >
                <Picture
                  alt="WHY US?"
                  fallback={require("images/leefiori/info/why-lee-fiori-2x.jpg")}
                  srcSet={[
                    {
                      media: "(max-width: 767px)",
                      sizes: "327vw",
                      srcSet: `
                          ${require("images/leefiori/info/why-lee-fiori-mobile.jpg")} 327w,
                          ${require("images/leefiori/info/why-lee-fiori-mobile-2x.jpg")} 654w
              `,
                    },
                    {
                      media: "(min-width: 768px)",
                      sizes: "244vw",
                      srcSet: `
                          ${require("images/leefiori/info/why-lee-fiori.jpg")} 244w,
                          ${require("images/leefiori/info/why-lee-fiori-2x.jpg")} 487w
              `,
                    },
                  ]}
                  width="100%"
                />

                <InfoBox
                  left={{ _: "25%", tablet: "auto" }}
                  right={{ _: "25%", desktop: "15%", tablet: "9%" }}
                  top={{ _: "34%", tablet: "auto" }}
                >
                  <InfoTitle>WHY US?</InfoTitle>
                  <Typography
                    fontSize={{
                      _: "1.0em",
                      tablet: "1.1em",
                    }}
                    mt={{ _: "16px", tablet: "1px" }}
                  >
                    No retail mark-ups.
                    <br />
                    Free {jewlr_t("terms.shipping")}.
                    <br />
                    99-day returns.
                  </Typography>
                </InfoBox>
              </Box>
            </Box>
            <Box as={Link} flex={1} mb={{ _: 4, tablet: 0 }} to="/materials">
              <Box
                alignItems="center"
                display={{ _: "block", tablet: "flex" }}
                flexDirection={{ tablet: "row-reverse" }}
                position="relative"
              >
                <Picture
                  alt="MATERIALS & CARE"
                  fallback={require("images/leefiori/info/materials-care-2x.jpg")}
                  srcSet={[
                    {
                      media: "(max-width: 767px)",
                      sizes: "327vw",
                      srcSet: `
                          ${require("images/leefiori/info/materials-care-mobile.jpg")} 327w,
                          ${require("images/leefiori/info/materials-care-mobile-2x.jpg")} 654w
              `,
                    },
                    {
                      media: "(min-width: 768px)",
                      sizes: "244vw",
                      srcSet: `
                          ${require("images/leefiori/info/materials-care.jpg")} 244w,
                          ${require("images/leefiori/info/materials-care-2x.jpg")} 487w
              `,
                    },
                  ]}
                  width="100%"
                />

                <InfoBox right={{ _: "25%", desktop: "9%", tablet: "3%" }}>
                  <InfoTitle>MATERIALS & CARE</InfoTitle>
                  <Typography
                    fontSize={{
                      _: "1.0em",
                      tablet: "1.1em",
                    }}
                    mt={{ _: "16px", tablet: "1px" }}
                  >
                    Fine {jewlr_t("terms.jewelry")}.
                    <br />
                    Quality crafted.
                    <br />
                    Amazing value.
                  </Typography>
                </InfoBox>
              </Box>
            </Box>
            <Box as={Link} flex={1} to="/giving_back">
              <Box
                alignItems="center"
                display={{ _: "block", tablet: "flex" }}
                flexDirection={{ tablet: "row-reverse" }}
                mb={{ _: 4, tablet: 0 }}
                position="relative"
              >
                <Picture
                  alt="GIVING BACK"
                  fallback={require("images/leefiori/info/materials-care-2x.jpg")}
                  srcSet={[
                    {
                      media: "(max-width: 767px)",
                      sizes: "327vw",
                      srcSet: `
                          ${require("images/leefiori/info/giving-back-mobile.jpg")} 327w,
                          ${require("images/leefiori/info/giving-back-mobile-2x.jpg")} 654w
              `,
                    },
                    {
                      media: "(min-width: 768px)",
                      sizes: "244vw",
                      srcSet: `
                          ${require("images/leefiori/info/giving-back.jpg")} 244w,
                          ${require("images/leefiori/info/giving-back.jpg-2x.jpg")} 487w
              `,
                    },
                  ]}
                  width="100%"
                />

                <InfoBox right={{ _: "25%", desktop: "12%", tablet: "6%" }}>
                  <InfoTitle>GIVING BACK</InfoTitle>
                  <Typography
                    fontSize={{
                      _: "1.0em",
                      tablet: "1.1em",
                    }}
                    mt={{ _: "16px", tablet: "1px" }}
                  >
                    Our Values.
                    <br />
                    Empowering Women.
                    <br />
                    Global Support.
                  </Typography>
                </InfoBox>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Modal
        height="75%"
        onClose={() => toggleShopperAlert(false)}
        show={showShopperAlert}
        width="600px"
      >
        <Typography
          as="h2"
          color="black"
          fontSize={18}
          fontWeight="normal"
          pb={2}
          textAlign="center"
        >
          Copying Prohibited by Law - This image and all included logos are
          copyrighted by Shopper Approved &#169; {new Date().getFullYear()}.
        </Typography>
      </Modal>
    </Box>
  )
}
export default About
